$(window).on("load",function(){
	$("body").removeClass("preload");
});

$(function(){

	var body = $('body');

	//SVGスプライト
	$.ajax({
		type: 'get',
		url: '/recruit/wp/wp-content/themes/comipura-recruit/assets/svg/icons.svg'//ここにパスを入れる（環境に合わせて変更）
	}).done(function(data) {
		var svg = $(data).find('svg');
		body.prepend(svg);
	});

	//スクロールアニメーション
	$('.animate').scrolla({
		mobile: true, // モバイルの有効・無効
		once: true, // 発火は１度だけか、視界に入るたびに発火させるか
		animateCssVersion: 4 // used animate.css version (3 or 4)
	});

	//ページ内スクロール
	$.smooziee();

	//スクロールしたらクラスを付与
	$(window).scroll(function () {
		if ($(this).scrollTop() > 160) {
			body.addClass("scroll");
		} else {
			body.removeClass("scroll");
		}
	});

	//スクロール上下でクラスを付与
	var beforePos = 0;//スクロールの値の比較用の設定
	function ScrollAnime() {
		var elemTop = 100
		// var elemTop = $('#area-2').offset().top;//#area-2の位置まできたら
		var scroll = $(window).scrollTop();
		//ヘッダーの出し入れをする
		if(elemTop > scroll || 0 > scroll - beforePos){
			body.addClass("scroll_up");
			body.removeClass('scroll_down');
		}else {
			body.addClass("scroll_down");
			body.removeClass('scroll_up');
		}
		beforePos = scroll;//現在のスクロール値を比較用のbeforePosに格納
	}
	// 画面をスクロールをしたら動かしたい場合の記述
	$(window).on('scroll', function(){
		ScrollAnime();
	});
	// ページが読み込まれたらすぐに動かしたい場合の記述
	$(window).on('load', function () {
		ScrollAnime();
	});

	//スマホ・PCのみ
	$(window).on('load resize', function(){
	// $(window).on('load', function(){
		var w = $(window).width();
		if (w <= 768) {
			//スマホ時
		} else {
			//PC時
		}
	});

	//タブ切り替え
	$(".tab_label").on("click",function(){
		var $th = $(this).index();
		$(this).parent().find(".tab_label").removeClass("active");
		$(this).parents().next().find(".tab_panel").removeClass("active");
		$(this).addClass("active");
		$(this).parents().next().find(".tab_panel").eq($th).addClass("active");
	});

	//ドロワーメニュー
	var $btn = $('.rct_drawer_btn');
	var $overlay = $('.rct_drawer_overlay');

	$btn.on('click', function () {
		body.toggleClass('menu_open');
	});
	$overlay.on('click', function () {
		body.removeClass('menu_open');
	});

	// サブメニュー（社員インタビューのアコーディオン）
	$('.rct_drawer_item.has_sub > a').on('click', function (e) {
		e.preventDefault();
		var $item = $(this).closest('.rct_drawer_item');
		$item.toggleClass('is_open');
		$item.find('.rct_drawer_sub').slideToggle(200);
	});

	//固定フッターナビ（スクロール100px以上で表示）
	var $fixnav = $('.rct_fixnav');
	if ($fixnav.length) {
		$(window).on('scroll', function () {
			if ($(this).scrollTop() > 100) {
				$fixnav.addClass('is_show');
			} else {
				$fixnav.removeClass('is_show');
			}
		});
	}

	//仕事の特徴スライダー
	if ($('.rct_features_swiper').length) {
		const swiper = new Swiper('.rct_features_swiper', {
			slidesPerView: 'auto',
			spaceBetween: 0,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
		});

		var el = document.querySelector('.rct_features_swiper');

		el.addEventListener('pointerdown', function () {
			swiper.autoplay.stop();
		});

		el.addEventListener('pointerup', function () {
			swiper.autoplay.start();
		});

		el.addEventListener('pointerleave', function () {
			swiper.autoplay.start();
		});
	}

	//MVのテキストアニメーション
	if ($('.rct_mv_catch_box_swiper').length) {
		new Swiper('.rct_mv_catch_box_swiper', {
			speed: 1, // 0だとSwiper12系でautoplayが止まるため1に
			autoplay: {
				delay: 100, // コマ送りの間隔（ms）
				disableOnInteraction: false,
				pauseOnMouseEnter: false,
			},
			loop: true,
			allowTouchMove: false,
		});
	}

	// よくあるご質問アコーディオン
	if ($('.rct_faqlist').length) {
		$('.rct_faqlist .ttl').on('click', function () {
			if($(this).hasClass('open')){
				$(this).removeClass('open');
			} else {
				$(this).addClass('open');
			}
			$(this).next(".txts").slideToggle();
		});
	} 


	// カウントアップ関数
	function countUpNumber($element) {
		const targetNumber = parseInt($element.data('target'));
		const duration = 1000;
		setTimeout(function() { // 遅延させてからスタート
			const startTime = Date.now();
			function update() {
				const elapsed = Date.now() - startTime;
				const progress = Math.min(elapsed / duration, 1);
				const currentNumber = Math.floor(targetNumber * progress);
				$element.text(currentNumber);
				
				if (progress < 1) {
					requestAnimationFrame(update);
				} else {
					$element.text(targetNumber);
				}
			}
			requestAnimationFrame(update);
		}, 100); // 500ms遅延
	}

	// 実行
	$(document).ready(function() {
		// console.log('スクリプト読み込み完了');
		
		// 既にanimate__animatedが付いている要素を実行
		$('.animate__animated').each(function() {
			const $this = $(this);
			
			// カウントアップ
			$this.find('.number').each(function() {
				const $number = $(this);
				if (!$number.hasClass('counted')) {
					// console.log('初期実行: カウント');
					$number.addClass('counted');
					countUpNumber($number);
				}
			});
			
			// グラフアニメーション
			// $this.find('.graph-img').each(function() {
			// 	const $graph = $(this);
			// 	if (!$graph.hasClass('animated')) {
			// 		// console.log('初期実行: グラフ');
			// 		$graph.addClass('animated');
			// 		animateGraph($graph);
			// 	}
			// });
		});
		
		// 今後付与される要素用のMutationObserver
		const observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				if (mutation.attributeName === 'class') {
					const $target = $(mutation.target);
					if ($target.hasClass('animate__animated')) {
						
						// カウントアップ
						$target.find('.number').each(function() {
							const $number = $(this);
							if (!$number.hasClass('counted')) {
								console.log('スクロールで実行: カウント');
								$number.addClass('counted');
								countUpNumber($number);
							}
						});
						
						// グラフアニメーション
						// $target.find('.graph-img').each(function() {
						// 	const $graph = $(this);
						// 	if (!$graph.hasClass('animated')) {
						// 		console.log('スクロールで実行: グラフ');
						// 		$graph.addClass('animated');
						// 		animateGraph($graph);
						// 	}
						// });
					}
				}
			});
		});
		
		$('.animate').each(function() {
			observer.observe(this, { attributes: true });
		});
	});

	//トップページのみの記述がある場合
	if($('.home').length){
	}

});

// //波のSVGアニメーション
// const WAVE_H = 60;
// const WAVE_REPEAT = 4;
// const WAVE_AMP = 20;
// const WAVE_P1 = 0.35 * WAVE_H;
// const WAVE_P2 = 0.4 * WAVE_H;
// const WAVE_P3 = 0.5 * WAVE_H;

// function makeWavePath(baseY, amp, cycles, totalW) {
// const pts = 200;
// let d = '';
// for (let i = 0; i <= pts; i++) {
// 	const x = (totalW / pts) * i;
// 	const y = baseY + Math.sin((i / pts) * cycles * Math.PI * 2) * amp;
// 	d += (i === 0 ? 'M' + x + ',' + y : ' L' + x + ',' + y);
// }
// d += ' L' + totalW + ',' + WAVE_H + ' L0,' + WAVE_H + ' Z';
// return d;
// }

// function initWave() {
// 	document.querySelectorAll('.wave-wrap').forEach(function(waveContainer) {
// 		let containerW = waveContainer.offsetWidth;
		
// 		// offsetWidthが0の場合は親またはwindow幅を使う
// 		if (containerW === 0) {
// 			containerW = waveContainer.closest('.wave-container')?.offsetWidth || window.innerWidth;
// 		}
// 		if (containerW === 0) return;
		
// 		const totalW = containerW * WAVE_REPEAT;

// 		waveContainer.querySelectorAll('.wave-svg').forEach(function(el) {
// 		el.setAttribute('width', totalW);
// 		el.setAttribute('height', WAVE_H);
// 		el.setAttribute('viewBox', '0 0 ' + totalW + ' ' + WAVE_H);
// 		});

// 		waveContainer.querySelector('.p1').setAttribute('d', makeWavePath(WAVE_P1, WAVE_AMP, 4, totalW));
// 		waveContainer.querySelector('.p2').setAttribute('d', makeWavePath(WAVE_P2, WAVE_AMP * 0.85, 4, totalW));
// 		waveContainer.querySelector('.p3').setAttribute('d', makeWavePath(WAVE_P3, WAVE_AMP * 0.70, 4, totalW));
// 	});
// }

// initWave(); // DOMContentLoaded時点でも実行
// window.addEventListener('load', initWave);
// window.addEventListener('resize', initWave);